import {Component, OnInit} from '@angular/core';
import {User} from "../../model/user";
import * as $ from 'jquery';
import {UserServiceService} from "../../service/user-service.service";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from "@angular/forms";
import {CustomValidators} from "../../CustomValidators";
import {environment} from "../../../environments/environment";
import {PlatformProfile} from "../../model/platformprofile";
import {PlatformUtils} from "../../utils/platform-utils";

/**
 * Account overview with options to change a users password and notification settings.
 */
@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css']
})
export class AccountComponent implements OnInit {

  user: User;
  currentMultiUserPlatform: PlatformProfile | undefined;
  showChangePasswordModal: boolean = false;
  showSuccessNotification: boolean = false;

  isRecipientsValid: boolean = true;
  isRecipientsCCValid: boolean = true;

  errorMsg: string;
  notificationForm: UntypedFormGroup;
  newPasswordForm: UntypedFormGroup;

  constructor(private readonly userService: UserServiceService, private formBuilder: UntypedFormBuilder) {

  }

  ngOnInit(): void {
    this.user = JSON.parse(sessionStorage.getItem("user"))
    this.currentMultiUserPlatform = PlatformUtils.getCurrentMultiUserPlatformProfileFromSession();

    this.newPasswordForm = this.formBuilder.group({
      oldPassword: new UntypedFormControl(null, Validators.required),
      password: new UntypedFormControl(null, Validators.compose([
        Validators.required,
        CustomValidators.patternValidator(/^(?=.*[0-9])/g, {hasNumber: true}),
        CustomValidators.patternValidator(/^(?=.*[a-z])/g, {hasSmallLetter: true}),
        CustomValidators.patternValidator(/^(?=.*[A-Z])/g, {hasBigLetter: true}),
        CustomValidators.patternValidator(/^(?=.*[_\-!?.@#$%^&*])/g, {hasSpecialCharacter: true}),
        Validators.minLength(8)
      ])),
      passwordConfirm: new UntypedFormControl(null, Validators.required),
    }, {validators: [CustomValidators.passwordMatchValidator]})


    this.notificationForm = this.formBuilder.group({
      recipients: new UntypedFormControl(null, Validators.email),
      recipientsCC: new UntypedFormControl(null, Validators.email),
      frequency: new UntypedFormControl("INSTANT"),
    });
  }

  displayChangePasswordModal() {
    $("#change-password-modal .modal").addClass("is-active");
    this.showChangePasswordModal = true;
  }

  updatePassword() {
    if (this.newPasswordForm.valid) {
      this.userService.updatePassword(this.user.id, this.newPasswordForm.value.oldPassword, this.newPasswordForm.value.password).subscribe(
          data => {
            if (JSON.parse(JSON.stringify(data)).status !== 500 && JSON.parse(JSON.stringify(data)).status !== undefined) {
              this.showSuccessNotification = true;
            }
            this.resetChangePasswordForm()
            this.showChangePasswordModal = false
          },
          error => {
            this.errorMsg = "Etwas ist schief gelaufen. Versuchen Sie es später noch einmal!"
          });
    }
  }

  updateNotificationSettings() {
    if (this.notificationForm.valid) {
      let notificationSettings = this.notificationForm.value;
      /*
      If the recipients or recipientsCC would be equal to "" the value inside the Database would also be "".
      If the recipients or recipientsCC are null the value inside the Database stays as it is.
       */
      if (notificationSettings.recipients === "") notificationSettings.recipients = null;
      if (notificationSettings.recipientsCC === "") notificationSettings.recipientsCC = null;
      this.userService.updateNotificationSettings(this.user.id, notificationSettings).subscribe(data => {
            this.showSuccessNotification = true
          },
          error => {
            this.errorMsg = "Etwas ist schief gelaufen. Versuchen Sie es später noch einmal!"
          });
    }
  }

  resetChangePasswordForm() {
    this.newPasswordForm.reset();
  }

  protected readonly window = window;
  protected readonly environment = environment;
}
